export default [
  {
    leerdoelen: ["1a", "1b"],
    voorkennis: []
  },
  {
    leerdoelen: ["2a"],
    voorkennis: ["1a"]
  }
];



// WEBPACK FOOTER //
// ./src/data/hoofdstukken-grieks.js